import HowToGetStarted from "../components/HowToGetStarted"; 
const Information = () =>{
  return (
     <>
      <h1 className = "text-center text-2xl font-bold">How Officialbillboard works</h1>
      <div>
        <p className = 'text-center text-xl'> Get involved in our tremendous platform and invest. We will utilize your money and give you profit in your wallet 
        </p>
      <HowToGetStarted />
    </div>
    </>
  ); 
}
export default Information; 
